import * as z from "zod";

export const MAX_ADDITIONAL_CLAIM_DOCUMENTS = 20;

export const submitAdditionalClaimDocuments = {
  name: "submitAdditionalClaimDocuments" as const,
  input: z.object({
    returnId: z.string(),
    documents: z
      .array(z.object({ fileName: z.string().min(1), url: z.string() }))
      .min(1)
      .max(MAX_ADDITIONAL_CLAIM_DOCUMENTS),
  }),
  output: z.object({ success: z.literal(true) }),
};
